import styled from "styled-components";

export const CMBoxContent = styled.div((props) => ({
  flexDirection: "row",
  flexWrap: "wrap",
  display: "flex",
  justifyContent: 'space-between',
  paddingBottom: 30,

  "&   .left-column": {
    paddingTop: 2,
    "&  h3": {
      fontFamily: props.theme.fontFamilies.jost,
      [`@media (min-width: 2000px)`]: {
        fontSize: '3vh'
       },
    },
    "&  h5": {
      fontWeight: "normal",
      fontFamily: props.theme.fontFamilies.jost,
      [`@media (min-width: 2000px)`]: {
        fontSize: '2.5vh'
       },
    },
    [`@media (min-width: 2000px)`]: {
      width: "50%",
      textAlign:"center"
    },
  },
  "& .right-column": {
    textAlign: "center",
    "& h4": {
      marginBottom: 0,
      marginTop: 0,
      fontFamily: props.theme.fontFamilies.WorkSans,
      [`@media (min-width: 2000px)`]: {
        fontSize: '2.5vh'
       },
    },
    "& .liveAuctionColor": {
      marginTop: 0,
      color: "#A80000",
      fontFamily: props.theme.fontFamilies.jost,
      [`@media (min-width: 2000px)`]: {
        fontSize: '2.5vh'
       },
    },
    [`@media (min-width: 2000px)`]: {
      width: "50%",
      textAlign:"center"
    },
  }, 
  [`@media${props.theme.breakpoints.xs}`]: {
    flexDirection: "column",
    height: "auto",
    "& .right-column": {
      textAlign: "left",
    },
   
  },
}));
export const CMDescription = styled.div((props) => ({
  flexDirection: "row",
  flexWrap: "wrap",
  display: "flex",
  paddingBottom: 35,
  paddingTop: 30,
  "& h5": {
    fontWeight: "normal",
    fontFamily: props.theme.fontFamilies.jost,
    [`@media (min-width: 2000px)`]: {
      fontSize: '2.5vh'
     },
  },
  "&   .left-column": {
    width: 246,
    [`@media (min-width: 2000px)`]: {
      width: "50%",
      textAlign:"center"
    },
  },
  "&   .right-column": {
    [`@media (min-width: 2000px)`]: {
      width: "50%",
      textAlign:"center"
    },
  },
  "&   .middle-column": {
    width: 246,
  },

  "&  .row": {
    flexBasis: "50%",
  },

  [`@media${props.theme.breakpoints.xs}`]: {
    flexDirection: "column",
    height: "auto",
  },
}));
export const CMButton = styled.div((props) => ({
  textAlign: "center",
  paddingBottom: 30,
  "& > button": {
    fontWeight: 500,
    fontSize: 28,
    width: 308,
    height: 53,
    padding: "5px 1rem",
    backgroundColor: props.theme.palette.green["700"],
    borderRadius: "30px",
    boxShadow:
      "rgba(0, 0, 0, 0.1) 0px 5px 25px -5px, rgba(0, 0, 0, 0.04) 0px 10px 10px -5px",
    "&:hover": {
      color: "white",
      borderColor: props.theme.palette.green["900"],
      backgroundColor: props.theme.palette.green["900"],
    },
    [`@media (min-width: 2000px)`]: {
      fontSize: '3vh',
      width: "25vh",
      height: "5vh",
     },
    [`@media${props.theme.breakpoints.sm}`]: {
      width: "100%"
    }
  },
}));
export const CMBoxPrice = styled.div((props) => ({
  flexDirection: "row",
  flexWrap: "wrap",
  display: "flex",
  paddingBottom: 21,
  "& h5": {
    fontWeight: "normal",
    fontFamily: props.theme.fontFamilies.jost,
    [`@media (min-width: 2000px)`]: {
      fontSize: '2.5vh'
    },
  },
  "&   .left-column": {
    width: 246,
    [`@media (min-width: 2000px)`]: {
      width: "50%",
      textAlign:"center"
    },
  },
  "&   .right-column": {
    [`@media (min-width: 2000px)`]: {
      width: "50%",
      textAlign:"center"
    },
  },

  "&  .row": {
    flexBasis: "50%",
  },

  [`@media${props.theme.breakpoints.xs}`]: {
    flexDirection: "column",
    height: "auto",
  },
}));
export const CMBoxcontainer = styled.div((props) => ({
  display: "flex",
  flexDirection: "column",
  marginLeft: 18,
  [`${CMLiveTag}`]: {
    top: 20,
  },
  "& CMBoxContent": {},

  [`@media${props.theme.breakpoints.xs}`]: {
    height: "auto",
  },
}));

export const CMLiveTag = styled.span`
  background-color: ${(props) => props.theme.palette.primary["500"]};
  color: white;
  padding: 1px 1rem 1px 1.5rem;
  position: absolute;
  top: 15px;
  left: 0;
  border-top-right-radius: 15px;
  border-bottom-right-radius: 15px;
  @media (min-width: 2000px) {
      font-size: 2.5vh;
  }
`;

export const CMOffer = styled.div((props) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  paddingBottom: "5%",

  "& Button": {
    height: 53,
    width: 204,
    fontWeight: 500,
    fontFamily: props.theme.fontFamilies.jost,
    fontSize: 28,
  },
  [`@media ${props.theme.breakpoints.lg}`]: {
    flexDirection: "column",
    alignItems: "center",
  },
  [`@media ${props.theme.breakpoints.xs}`]: {
    flexDirection: "column",
    alignItems: "center",
  },
}));

export const CMListsTable = styled.div((props) => ({
  fontWeight: "normal",
  fontSize: props.theme.fontSizes.h5,
  paddingLeft: 18,
  fontFamily: props.theme.fontFamilies.Jost,
  height:"20%",
  "& .MuiDataGrid-root": {
    "& .MuiDataGrid-cell": {
      boxSizing: "none",
      borderBottom: `solid 1px #e5e5e5`,
      backgroundPosition: "bottom",
      backgroundRepeat: "no-repeat",
      backgroundSize: "unset",
      backgroundImage: "unset",
    },
    "& .MuiDataGrid-virtualScroller": {
      marginTop: "35px !important",
      [`@media (min-width: 2000px)`]: {
        marginTop: "4vh !important",
        height:"20vh !important"
      },
      "& .MuiDataGrid-virtualScrollerContent": {
      [`@media (min-width: 2000px)`]: {
        height:"5vh !important"
      },
      "& .MuiDataGrid-virtualScrollerRenderZone": {
      [`@media (min-width: 2000px)`]: {
        height:"5vh !important",
        "& div":{
          height:"5vh !important",
          maxHeight:"100% !important",
          minHeight:"5vh !important",
          fontSize:"2.5vh !important",
        }
      },
    },
    },
      
    },
    "& .MuiTablePagination-root": {
      "& div p":{
        [`@media (min-width: 2000px)`]: {
        fontSize:"2.5vh"
      },
      }
    },
    "& .MuiDataGrid-main": {
      [`@media (min-width: 2000px)`]: {
        fontSize:"2.5vh"
      },
    },
    "& .MuiDataGrid-columnHeaders": {
      [`@media (min-width: 2000px)`]: {
        maxHeight:"100% !important",
        height:"3vh",
        fontSize:"2.5vh",
      },
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: "normal",
      fontSize: props.theme.fontSizes.h5,
      fontFamily: props.theme.fontFamilies.Jost,
      [`@media (min-width: 2000px)`]: {
        fontSize:"2vh",
        height:"10vh",
        alignContent:"center"
      },
      [`@media ${props.theme.breakpoints.sm}`]: {
        fontSize: 12
      }
    },
    "& .MuiDataGrid-columnHeaderTitleContainer": {

      [`@media (min-width: 2000px)`]: {
        height:"3vh !important",
      },
    },
    "& .MuiDataGrid-columnHeaderDraggableContainer": {
      [`@media (min-width: 2000px)`]: {
        height:"3vh !important",
      },
    },
    "& .MuiDataGrid-cellContent": {
      fontWeight: "normal",
      fontSize: props.theme.fontSizes.h5,
      fontFamily: props.theme.fontFamilies.Jost,
      [`@media ${props.theme.breakpoints.sm}`]: {
        fontSize: 12
      }
    },
    "& .MuiTablePagination-actions": {
      [`@media (min-width: 2000px)`]: {
        "& svg":{
          width:"2.5vh",
          height:"2.5vh",
        }
      },
    },
  },
}));
export const CMTtileColumn = styled.div((props) => ({
  width: "100%",
  "& p": {
    display: "inline-block",
    width: "100%",
    textAlign: "center",
  },
  "& span": {
    color: props.theme.palette.gray["900"],
  },
}));
